// actions.js
import {
  FETCH_SECTORS_REQUEST,
  FETCH_SECTORS_SUCCESS,
  FETCH_SECTORS_FAILURE,
  DELETE_SECTORS_REQUEST,
  DELETE_SECTORS_FAILURE,
  DELETE_SECTORS_SUCCESS,
  FETCH_SECTOR_REQUEST,
  FETCH_SECTOR_SUCCESS,
  FETCH_SECTOR_FAILURE,
  UPDATE_SECTORS_REQUEST,
  UPDATE_SECTORS_SUCCESS,
  UPDATE_SECTORS_FAILURE,
  FETCH_SECTORS_RELEASE_REQUEST,
  FETCH_SECTORS_RELEASE_SUCCESS,
  FETCH_SECTORS_RELEASE_FAILURE,
  OPEN_EDIT_PAGE_SECTOR,
  OPEN_EDIT_PAGE_SECTOR_SUCCESS,
  CLEAR_SECTOR_ERRORS,
  CLEAR_SECTOR_SUCCESS,
} from './actionTypes';

export const fetchSectorsRequest = () => ({
  type: FETCH_SECTORS_REQUEST,
});

export const fetchSectorsSuccess = (sectors) => ({
  type: FETCH_SECTORS_SUCCESS,
  payload: sectors,
});

export const fetchSectorsFailure = (error) => ({
  type: FETCH_SECTORS_FAILURE,
  payload: error,
});

export const fetchSectorsReleaseRequest = () => ({
  type: FETCH_SECTORS_RELEASE_REQUEST,
});

export const fetchSectorsReleaseSuccess = (sectorsRelease) => ({
  type: FETCH_SECTORS_RELEASE_SUCCESS,
  payload: sectorsRelease,
});

export const fetchSectorsReleaseFailure = (error) => ({
  type: FETCH_SECTORS_RELEASE_FAILURE,
  payload: error,
});

export const fetchSectorRequest = (id) => ({
  type: FETCH_SECTOR_REQUEST,
  payload: id
});

export const fetchSectorSuccess = (sector) => ({
  type: FETCH_SECTOR_SUCCESS,
  payload: sector,
});

export const fetchSectorFailure = (error) => ({
  type: FETCH_SECTOR_FAILURE,
  payload: error,
});

export const updateSectorRequest = (sector, navigate) => ({
  type: UPDATE_SECTORS_REQUEST,
  payload: { sector, navigate }
});

export const updateSectorSuccess = () => ({
  type: UPDATE_SECTORS_SUCCESS,
});

export const updateSectorFailure = (error) => ({
  type: UPDATE_SECTORS_FAILURE,
  payload: error,
});

export const openEditPageSector = (id, navigate) => ({
  type: OPEN_EDIT_PAGE_SECTOR,
  payload: { id, navigate }
});

export const openEditPageSectorSuccess = () => ({
  type: OPEN_EDIT_PAGE_SECTOR_SUCCESS,
});

export const deleteSectorRequest = (id) => ({
  type: DELETE_SECTORS_REQUEST,
  payload: id
});

export const deleteSectorSuccess = (id) => ({
  type: DELETE_SECTORS_SUCCESS,
  payload: id,
});

export const deleteSectorFailure = (error) => ({
  type: DELETE_SECTORS_FAILURE,
  payload: error,
});

export const clearSectorErrors = () => ({
  type: CLEAR_SECTOR_ERRORS,
});

export const clearSectorSuccess = () => ({
  type: CLEAR_SECTOR_SUCCESS,
});